<template>
    <GeneralDashboardLayout>
      <template v-slot:header>
        <div class="header-template">
          <BackButton :to="{ name: 'event_dashboard.index' }" />
          <h1 class="title text-center">Exhibition Area</h1>
          <span >
            <button class="btn btn-outline-primary" @click="createClick" v-if="is_new === false">Create a New Exhibition Area</button>
            <button class="btn btn-outline-primary" @click="cancelClick" v-else>Cancel</button>
          </span>
        </div>
      </template>
      <template v-slot:content>
        <div class="container-fluid exhibitor-container">
          <div class="row">
            <div class="col-lg-12">
              <div id="live-presentations">
                <OverlayLoading :isLoading="loading" />
                <SearchableContainer :all="all" :search="search" v-slot="props" :perPage="this.perPage" >
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row search_bar">
                        <div class="col-md-2">
                          <div class="input-group w-70">
                            <select class="form-control input-rounded mb-3 pageview" @change="perRowChange">
                              <option value="5">5</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                            </select>
                          </div>
                          <span class="ml-5 rpg_txt">records per page</span>
                        </div>
                        <div class="col-md-2 offset-md-8 ">
                          <div class="input-group">
                            <input type="text" class="form-control pageview" placeholder="Search" v-model="search">
                            <span class="input-group-text">
                              <i class="fas fa-search"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="labelhdwrapper row">
                    <span class="col1">Name</span>
                    <span class="col2">Exhibition Area Type</span>
                  </div>
                  <TogglePrimaryActive v-if="is_new">
                    <template v-slot:default>
                      <EventExhibtionHallCreate />
                    </template>
                  </TogglePrimaryActive>
                  <TogglePrimary v-for="(exhibitor, index) in props.all" v-bind:key="index">
  
                    <template v-slot:label>
                        <span class="labelwrapper">
                          <span class="col1">{{ exhibitor.name }}</span>
                          <span class="col1">{{ exhibitor.type }}</span>
                        </span>
                  </template>
                    <template v-slot:default>
                      <EventExhibtionHallEdit v-if="is_new === false && is_editing === true && exhibitor._id === item._id" :item="exhibitor" />
                      <EventExhibtionHallShow :item="exhibitor" v-else />
                    </template>
                  </TogglePrimary>
                </SearchableContainer>
              </div>
            </div>
          </div>
          <FlashMessage group="event_exhibition_area_index" />
        </div>
      </template>
    </GeneralDashboardLayout>
  </template>
  
  <script>
  import _ from 'lodash';
  import {mapGetters, mapActions} from 'vuex'
  import BackButton from "@/components/Commons/BackButton";
  import GeneralDashboardLayout from "@/components/layouts/GeneralDashboardLayout";
  import TogglePrimary from "@/components/Commons/TogglePrimary";
  import SearchableContainer from "@/components/Commons/SearchableContainer";
  import EventExhibtionHallCreate from "@/components/cruds/ExhibitionHall/Create";
  import EventExhibtionHallShow from "@/components/cruds/ExhibitionHall/Show";
  import EventExhibtionHallEdit from "@/components/cruds/ExhibitionHall/Edit";
  import { isPermits} from "@/services/CheckPermissions";
  import TogglePrimaryActive from "@/components/Commons/TogglePrimaryActive";
  
  export default {
    name: "EventExhibtionHallIndex",
    components: {
      EventExhibtionHallCreate,
      EventExhibtionHallEdit,
      EventExhibtionHallShow,
      SearchableContainer,
      TogglePrimary,
      BackButton,
      GeneralDashboardLayout,
      TogglePrimaryActive
    },
    data() {
      return {
        search: null,
        perPage: 5,
      }
    },
    computed: {
      ...mapGetters("AuthenticationsIndex",{checkPermssions:"all", role:"role",isCan:"isCan"}),
      ...mapGetters('ExhibitionAreasIndex', ['loading', 'all', 'edit_id']),
      ...mapGetters('ExhibitionAreasSingle', ['item', 'is_new', "is_editing"]),
    },
    created() {
       this.fetchData(this.$route.params.event_id);
      //this.fetchPermissions()
      this.verifyPermissions(this.$route.params.event_id)
    },
    beforeUnmount() {
      this.resetState();
      delete this.$flashMessage.groups.event_exhibition_area_index;
      delete this.$flashMessage.groups.exhibition_area_edit;
    },
    methods: {
      ...mapActions("AuthenticationsIndex",["fetchPermissions","fetchPermissionsOnLoad","verifyPermissions"]),
      ...mapActions('ExhibitionAreasIndex', ['fetchData']),
      ...mapActions('ExhibitionAreasSingle', ['resetState', "setIsNew", "setIsEditing"]),
      createClick() {
        this.setIsNew(true);
        this.setIsEditing(false);
      },
      cancelClick() {
        this.resetState();
      },
      perRowChange(e) {
        this.perPage = Number(e.target.value);
      },
      can(permit,permissions){
        return isPermits(permit,permissions);
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .header-template {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
  
    .title {
      font-size: 1.6rem;
    }
  }
  
  .exhibitor-container {
    .form-control {
      font-family: 'Poppins';
    }
  
    .labelwrapper {
      width: 100%;
    }
  
    .labelhdwrapper {
      width: 100%;
      margin-left: 0px;
      border: 1px solid #ccc;
      padding: 10px;
      background: #e1e1e1;
    }
  
    .labelhdwrapper span {
      font-weight: bold;
    }
  
    .col1 {
      width: 25%;
      display: inline-flex;
    }
  
    .col2 {
      width: 25%;
      display: inline-flex;
    }
  
    .col3 {
      width: 25%;
      display: inline-flex;
    }
  
    .col4 {
      width: 20%;
      display: inline-flex;
    }
  
    .search_bar {
      margin-bottom: 20px;
    }
  
    .pageview {
      font-family: 'Poppins';
      font-size: 1em !important;
    }
  
    .w-70 {
      width: 30%;
      display: inline-flex;
    }
  
    .rpg_txt {
      display: inline-block;
      margin-left: 10px;
    }
  }
  
  </style>
  
  
  